/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.4",
    versionName: "0.2.0-nightly.2025.10.4",
    versionChannel: "nightly",
    buildDate: "2025-10-04T00:07:32.982Z",
    commitHash: "e3d6fe75e66a9911c83f0f40811a1cb39498fe8f",
};
